import { Tab as ChakraTab } from "@chakra-ui/react";
import type React from "react";
import type { FunctionComponent } from "react";

type TabProps = React.ComponentProps<typeof ChakraTab>;

export const Tab: FunctionComponent<React.PropsWithChildren<TabProps>> = ({
  children,
  ...props
}) => (
  <ChakraTab
    mb="-1px"
    color="gray.600"
    fontWeight="medium" // Reset default style
    border=""
    borderWidth="1px"
    borderColor="gray.300"
    borderBottomWidth="4px"
    borderBottomColor="transparent"
    _selected={{
      color: "teal.700",
      borderBottomColor: "teal.500",
      borderBottomWidth: "4px",
      bgColor: "white",
    }}
    _first={{
      borderTopLeftRadius: "xl",
    }}
    _last={{
      borderTopRightRadius: "xl",
    }}
    _notFirst={{
      borderLeft: "unset",
    }}
    {...props}
  >
    {children}
  </ChakraTab>
);
